import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-savingswithdrawalssettings',
  templateUrl: './savingswithdrawalssettings.component.html',
  styleUrls: ['./savingswithdrawalssettings.component.css']
})
export class SavingswithdrawalssettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
